//export const PROD_URL = "https://staging-api.myheartline.com/api/";
// export const PROD_URL = "https://localhost:44397/api/";
export const PROD_URL = "https://core.myheartline.com/api/";
